var _defs, _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "play-icon-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006ad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a6fb"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "play-icon-blue",
    width: 124,
    height: 124,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#006ad9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#play-icon-blue)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#006ad9",
    strokeWidth: 2,
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 52
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#play-icon-gradient)",
    d: "M.013 0v14.9q2.866 2.7 5.487 5.65V8.481a84.441 84.441 0 0 1 18.738 15.857A83.5 83.5 0 0 1 5.5 40.208V28Q2.882 30.962.013 33.672v9.47L0 43.149v5.527a55.305 55.305 0 0 0 7.418-3.6 89.191 89.191 0 0 0 23.5-20.758A89.546 89.546 0 0 0 7.2 3.455 54.4 54.4 0 0 0 .013 0Z",
    transform: "translate(51.5 36.662)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.3868d4433d7ee7ad6a1e65e43534572f.svg";
export { ForwardRef as ReactComponent };